module.exports = __webpack_public_path__ + "static/img/2013.7446673.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2013.jpg
// module id = 304
// module chunks = 0